
import LoginFlowStepEmail from '@/components/forms/LoginFlowStepEmail.vue'
import LoginFlowStepOTP from '@/components/forms/LoginFlowStepOTP.vue'
import LoginFlowStepOTPUnavailable from '@/components/forms/LoginFlowStepOTPUnavailable.vue'
import LoginFlowStepPassword from '@/components/forms/LoginFlowStepPassword.vue'
import type { LoginFlowStep } from '@/components/forms/types'
import EventBus from '@/helpers/EventBus'
import store from '@/store/store'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'LoginFlow',
  components: { LoginFlowStepEmail, LoginFlowStepPassword, LoginFlowStepOTP, LoginFlowStepOTPUnavailable },
})
export default class extends Vue {
  @Prop()
  hideForgotLink: boolean

  @Prop()
  showBecomeMemberLink: boolean

  step: LoginFlowStep = 'email'

  created() {
    EventBus.$on('request-code-link-clicked', this.backToEmail)

    const isFromMagicLink = this.$route.query.otp
    if (!isFromMagicLink) return

    const loginFlowData = store.getters['LoginFlow/all']
    const { email, token, redirectPath } = loginFlowData
    const hasAllOTPData = email && token && redirectPath

    this.goToStep(hasAllOTPData ? 'otp_form' : 'otp_unavailable')
  }

  destroyed() {
    store.dispatch('LoginFlow/clearAll')
  }

  goToStep(step: LoginFlowStep) {
    this.step = step
  }

  backToEmail() {
    this.goToStep('email')
  }
}
